import { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import LoadingButton from "@mui/lab/LoadingButton";
import { DialogContentText, Typography } from "@mui/material";
interface Props {
  open: boolean;
  categoryLoading: boolean;
  handleClose: () => void;
  deleteCategory: (data: any) => void;
  modalData: any;
}

export default function DeleteCategoryModal({
  open,
  handleClose,
  modalData,
  deleteCategory,
  categoryLoading,
}: Props) {
  

  return (
    <div>
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="draggable-dialog-title"
          >
            <DialogTitle
              sx={{ mb: 0 }}
              style={{ cursor: "move" }}
              id="draggable-dialog-title"
            >
            {modalData.category_name}
            </DialogTitle>
            <DialogContent>
              <DialogContentText>
                Are you sure you want to {modalData?.category_name} {" "} Category?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button variant="outlined" onClick={handleClose}>
                Cancel
              </Button>
              <LoadingButton
                loading={categoryLoading}
                color={"error"}
                variant="contained"
                onClick={() => deleteCategory(modalData)}
              >
                Delete
              </LoadingButton>
            </DialogActions>
          </Dialog>
        </div>
  );
}
